<template>
  <div class="">
    <div class="apegar mt-3">
      <div class="row gy-0 shadow">
        <div class="col-12">
          <h2 class="mt-4 mb-3">REGISTRAR LINK POWER BI</h2>
        </div>
        <!-- 
        <div class="col-4 rounded mt-5">
          <select
            @change="Empresa($event)"
            class="form-select p-2"
            aria-label="Default select example"
          >
            <option selected>Seleccionar Empresa...</option>
            <option
              class="text-center"
              v-for="empresa in DniEmpre"
              :key="empresa.id"
              :value="empresa.id"
            >
              {{ empresa.empNomCorto }}
            </option>
          </select>
        </div>
        <div class="col-4 rounded mt-5">
          <select
            @change="Centro($event)"
            class="form-select p-2"
            aria-label="Default select example"
          >
            <option selected>Seleccionar Centro ...</option>
            <option
              v-for="centro in CentroCosto"
              :key="centro.id"
              :value="centro.cenCodigo"
            >
              {{ centro.cenNombre }}
            </option>
          </select>
        </div>
        -->
        <div class="col-12 rounded mt-5">
          <select
            @change="handleSelection"
            class="form-select p-2"
            aria-label="Default select example"
          >
            <option selected>Seleccionar cliente...</option>
            <option
              v-for="listado in listadoAdmin"
              :key="listado.id"
              :value="listado.idClientesBI"
            >
              <!-- :value="subCentro.id " -->

              {{ listado.nomSubCentro }}
            </option>
          </select>
        </div>

        <div class="col-12 py-3 rounded">
          <input
            v-model="linkBI"
            type="text"
            class="form-control mt-3 p-2"
            id="exampleFormControlInput1"
            placeholder="link Power BI"
          />
        </div>

        <div class="col-12 py-3 rounded">
          <input
            v-model="tituloBI"
            type="text"
            class="form-control mt-3 p-2"
            id="exampleFormControlInput1"
            placeholder="titulo del reporte"
          />
        </div>
        <div class="col-12 py-3 rounded">
          <button @click="Registrar" class="btn btn-success mb-4 p-2 w-100">
            REGISTRAR
          </button>
        </div>
      </div>
    </div>

    <div class="mt-5 mx-3">
      <table class="table table-bordered">
        <thead class="bg-primary">
          <tr class="text-nowrap">
            <th scope="col">ID</th>
            <th scope="col">SUB CENTRO</th>
            <th scope="col">NOMBRE</th>
            <th scope="col">TITULO REPORTE</th>
            <th scope="col">LINK</th>
            <th scope="col">ELIMINAR</th>
          </tr>
        </thead>
     
        <tbody>
          <tr
            class="text-nowrap"
            v-for="(lista, index) in listadoClientesTabla.slice(numero-6 , numero)"
            :key="index.id"
          >
            <th scope="row">{{lista.indice}}</th>
            <td>{{ lista.nomSubCentro }}</td>
            <td>{{ lista.nomContacto }} {{ lista.apeContacto }}</td>
            <td>{{ lista.nombreBi}} </td>
            <td>     <a :href="lista.linkBI" target="_blanck">{{ lista.linkBI.slice(0,50)}}</a>  </td>
            <td><button @click="EliminarLinks(lista.idLink)" class="btn btn-light"><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-trash3 text-danger" viewBox="0 0 16 16">
  <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
</svg></button></td>
          </tr>
        </tbody>
      </table>

      <button class="btn btn-primary mx-2" @click="retrocedere"> {{ retroceder }}</button>
      <button class="btn btn-danger">{{ pag }}</button>
      <button  class="btn btn-primary mx-2" @click="avanza"> {{ avanzare }} </button>
    </div>
  </div>
</template>


<script>
import Swal from "sweetalert";
import Swale from 'sweetalert2'

export default {
  name: "BYAdministracion",

  data() {
    return {
      dniTrabajador: null,
      cenCodigoCentro: "",

      numero : 6,
      pag: 1,
      retroceder:"<",
      avanzare: ">",

      linkBI: "",
      idTrabajador: "",
      idCliente: "",
      tituloBI: "",
      idUsuario:"",
      listadoAdmin: [],
      listadoClientesTabla: [],

      clientesData: {}, // Objeto para almacenar los datos de los clientes
    };
  },

  mounted() {
    this.idTrabajador = localStorage.getItem("idTrabajdor");
    this.dniTrabajador = localStorage.getItem("dniUsers");
    this.idContacto = localStorage.getItem("idContacto");
    this.idUsuario = localStorage.getItem("userId")
  },


  created() {
    this.listados();
    this.listadoXinsertados();
  },

  computed: {},

  methods: {

    avanza(){
      this.numero = this.numero+6
      this.pag = this.pag + 1
      console.log(this.numero)
    },

    retrocedere(){
      this.numero = this.numero - 6
      this.pag  = this.pag - 1
    },


    listadoXinsertados() {
      this.axios.get("BIClientes/ListarLinkxCliente").then((r) => {
        console.log(r.data);
        this.listadoClientesTabla = r.data;
      });
    },

    listados() {
      this.axios.get("BIClientes/ListClientesxContacto").then((r) => {
        console.log(r.data);
        this.listadoAdmin = r.data;
      });
    },

    // idClientes(event) {
    //   this.idCliente = event.target.value;
    // },

    handleSelection(event) {
      this.idCliente = event.target.value;
      const selectedValue = parseInt(event.target.value);
      const clienteData = this.listadoAdmin.find(
        (cliente) => cliente.idClientesBI === selectedValue
      );

      if (clienteData) {
        this.clientesData[selectedValue] = clienteData;

        // console.log(clienteData);
        // console.log(this.clientesData[selectedValue]);
      }
    },

    Registrar() {
      const from = {
        idClientesBI: `${this.idCliente}`,
        idUsuario: `${this.idUsuario}`,
        linkBI: `${this.linkBI}`,
        nombreBi: `${this.tituloBI}`,
        
      };
      //   p
      this.axios.post("BIClientes/RegistrarBI", from).then((r) => {
        // console.log(r.data);
        if (r.data == true) {
          Swal("Se registro link", "", "success");
          this.idCliente = "";
          this.linkBI = "";
          this.tituloBI = "";
          this.listadoXinsertados();
        }else{
          Swal("Error al registrar", "", "warning");
          this.idCliente = "";
          this.linkBI = "";
          this.tituloBI = "";
          this.listadoXinsertados();
        }
      }).catch(error =>{
        if(error.response.status == 400){
          Swal("llenar todos los campos", "", "warning");
         
          this.listadoXinsertados();
        }
      });
      //
    },

    EliminarLinks(id){
      console.log(id)

      Swale.fire({
  title: 'Estas seguro?',
  text: "¡No podrás revertir esto!",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonColor: '#3085d6',
  cancelButtonColor: '#d33',
  confirmButtonText: '¡Sí, bórralo!'
}).then((result) => {
  if (result.isConfirmed) {
    this.axios.delete(`BIClientes/EliminarLink?idLink=${id}`).then(r => {
        console.log(r.data)
        this.listadoXinsertados()
      })
      
    Swale.fire(
      '¡Eliminado!',
      'Ha sido Eliminado',
      'success'
    )
  }
})

     

    }
  },
};
</script>

<style scoped>
.apegar {
  padding-left: 18%;
  padding-right: 18%;
}
</style>
